import BasePage from  './basePage';
import VideoPlayer from "promokit-youtubeplayer";
import Layer from "promokit-layer"


export default class Skill1 extends BasePage{
  constructor(info){
    super(info);
    this.showMotion;
    this.btns = this.ele.querySelectorAll('.skill-list>li');
    this.selectBtn = null;
    this.leady = false;
    this.layer = new Layer();
    this.player = null;

    //this.playMovie = null;
    /*this.moviesInfo = [
      {el:'#skill1-video-1', videoId:'pfMwVK71z7E'},
      {el:'#skill1-video-2', videoId:'AAKscl07MlE'},
      {el:'#skill1-video-3', videoId:'pfMwVK71z7E'},
      {el:'#skill1-video-4', videoId:'AAKscl07MlE'}
      ];
*/
    this._motionSet();
    this._eventSet();


  }
  _eventSet(){
    this.ele.querySelector('.skill-movie-btn').addEventListener('click', (e)=>{


      this.ele.dispatchEvent(new CustomEvent("pageEvent", {detail:{action:'showLayer'}}));
      this.layer.open(document.querySelector("#layer-skill1").innerHTML);

      if(this.player === null){
        this.player = new VideoPlayer({
          el: "#sill1-video",
          videoId: "_8IJA_NlqnA",
          loop: false,
          autoPlay: false
        });
        this.player.on("canplay", ()=>{

          this.player.play();
        })
      }
      document.querySelector('.layer-skill1 .close').addEventListener('click', (e)=>{
        this.layer.close();
      });


    });

    this.layer.on('layercloseend', ()=>{
      this.ele.dispatchEvent(new CustomEvent("pageEvent", {detail:{action:'hideLayer'}}));

      this.player.stop();
      this.player.pause();
      this.player = null;
    })

    for(let btn of this.btns) {
      btn.querySelector('button:not(.close)').addEventListener('mouseenter', (e) => {
        if(!this.leady)return;
        this._overAct(e.currentTarget.parentElement.parentElement.parentElement)
      });

      btn.querySelector('button:not(.close)').addEventListener('mouseleave', (e) => {
        if(!this.leady)return;
        this._outAct(e.currentTarget.parentElement.parentElement.parentElement)
      });

      btn.querySelector('button:not(.close)').addEventListener('click', (e) => {
        if(!this.leady)return;
        this._selectAct(e.currentTarget.parentElement.parentElement.parentElement)
      });

      btn.querySelector('.close').addEventListener('click', (e) => {
        if(!this.leady)return;
        this._selectAct(null)
      });
    }

    /*for(let movie of this.moviesInfo){
      let mo = new VideoPlayer({
        el: movie.el,
        videoId: movie.videoId,
        loop: false,
        autoPlay: false
      });
      mo.on("play", (e)=>{
        this.playMovie = mo;
      })
    }*/



  }
  _overAct(btn){
    if(!btn)return;
    TweenMax.to(btn.querySelector('.active'), 0.3, {autoAlpha:1})
  }

  _outAct(btn){
    if(btn === this.selectBtn)return;
    if(!btn)return;
    TweenMax.to(btn.querySelector('.active'), 0.3, {autoAlpha:0})
  }

  _selectAct(selectBtn){
    if(selectBtn == this.selectBtn)return;
    let currentBtn = this.selectBtn;
    for(let btn of this.btns) {
      btn.querySelector(':scope>dl>dd').setAttribute('style', 'display:none');
    }

   /* if(this.playMovie){
      this.playMovie.stop();
      this.playMovie = null;
    }*/
    if(selectBtn){
      TweenMax.set(selectBtn.querySelector(':scope>dl>dd'), {css:{display:'block', opacity:0}})
      TweenMax.to(selectBtn.querySelector(':scope>dl>dd'), 0.3, {autoAlpha:1})
    }

    this.selectBtn = selectBtn;
    this._outAct(currentBtn);
    this._overAct(this.selectBtn)
  }
  _motionSet(){
    this.showMotion = new TimelineMax({paused: true, onComplete: this._showCompleteContent, onCompleteParams: [this]});
    this.showMotion
      .fromTo(this.ele.querySelector('.chr-1'), 3, {autoAlpha:0, x:400}, {autoAlpha:1, x:0, ease: 'chr'}, '+=0.5')
      .fromTo(this.ele.querySelector('.chr-1>span'), 1, {autoAlpha:1}, {autoAlpha:0, ease: Quart.easeInOut}, '-=2')

      .addLabel('obj', '-=2.5')
      .fromTo(this.ele.querySelector('.txt-1'), 1, {autoAlpha:0, y:30}, {autoAlpha:1, y:0, ease: Quart.easeOut}, 'obj')
      .fromTo(this.ele.querySelector('.txt-2'), 1, {autoAlpha:0, y:30}, {autoAlpha:1, y:0, ease: Quart.easeOut}, 'obj+=0.3')
      .fromTo(this.ele.querySelector('.txt-1>span'), 1, {autoAlpha:1}, {autoAlpha:0, ease: Quart.easeOut}, 'obj+=0.6')
      .fromTo(this.ele.querySelector('.skill-movie-btn'), 0.5, {y:-20, autoAlpha:0}, {y:0, autoAlpha:1, ease: Quart.easeOut}, 'obj+=1.5')
      .fromTo(this.ele.querySelector('.icon-scroll'), 0.5, {autoAlpha:0, y:50}, {autoAlpha:0.8, y:0, ease: Quart.easeOut}, 'obj+=1.7')

      .staggerFromTo(this.ele.querySelectorAll('.skill-list--1>li .active'), 0.5, {autoAlpha:0, y:50}, {autoAlpha:1, y:0, ease: Power1.easeOut}, -0.1, 'obj+=0.9')
      .staggerFromTo(this.ele.querySelectorAll('.skill-list--1>li .default'), 0.5, {autoAlpha:0}, {autoAlpha:1}, -0.1, 'obj+=1.4')
      .staggerTo(this.ele.querySelectorAll('.skill-list--1>li .active'), 0.5, {autoAlpha:0}, -0.1, 'obj+=1.4')
      .staggerFromTo(this.ele.querySelectorAll('.skill-list--2>li .active'), 0.5, {autoAlpha:0, y:-50}, {autoAlpha:1, y:0, ease: Power1.easeOut}, 0.1, 'obj+=0.8')
      .staggerFromTo(this.ele.querySelectorAll('.skill-list--2>li .default'), 0.5, {autoAlpha:0}, {autoAlpha:1}, 0.1, 'obj+=1.3')
      .staggerTo(this.ele.querySelectorAll('.skill-list--2>li .active'), 0.5, {autoAlpha:0}, 0.1, 'obj+=1.3')


    //this.player.stop();
  };
  show(size, dx){
    super.show(size, dx)
    this.showMotion.seek(0)
    this.showMotion.play();
  }
  hide(size, dx, moveSec){
    super.hide(size, dx, moveSec)
    this.showMotion.pause();
    this.leady = false;
    this._selectAct(null)
  }
  _showCompleteContent(thisv){
    thisv.leady = true;
  }
}



// WEBPACK FOOTER //
// ./src/js/page/skill1.js